import { CommonTextInputField, RepeatableOneInputField } from "@/components";
import React from "react";

const ServiceInfoFieldSection = ({
  control,
  errors,
  formData,
  handleAddRepeatableField,
  handleOnChangeRepeatableFields,
  handleRemoveRepeatableField,
  isItemDetailsExist = false,
  isHideInOtherLanguages = false,
}) => {
  return (
    <>
      {/* Service Info Title */}
      <CommonTextInputField
        fieldName="service_info_title"
        fieldType="text"
        fieldId={
          isItemDetailsExist
            ? "service-update-info-title"
            : "service-info-title"
        }
        control={control}
        errors={errors}
        errorsType={errors?.service_info_title}
        placeholderText="Title"
        labelName="Info Title"
        inputBoxMaxWidth="xl:max-w-[500px]"
        translateField={isItemDetailsExist}
      />

      {/* Service Info Sub Title */}
      <CommonTextInputField
        fieldName="service_info_sub_title"
        fieldType="text"
        fieldId={
          isItemDetailsExist
            ? "service-update-info-sub-title"
            : "service-info-sub-title"
        }
        control={control}
        errors={errors}
        errorsType={errors?.service_info_title}
        placeholderText="Sub Title"
        labelName="Info Sub Title"
        inputBoxMaxWidth="xl:max-w-[500px]"
        extraClass="mt-5"
        translateField={isItemDetailsExist}
      />

      {/* Service Info Key Points */}
      <RepeatableOneInputField
        formData={formData}
        labelText="Info Key Points"
        fieldId={
          isItemDetailsExist
            ? "service-update-info-key-points"
            : "service-info-key-points"
        }
        translateField={isItemDetailsExist}
        repeatableKeyname="service_info_key_points"
        repeatableKeys={["points"]}
        addNewField={handleAddRepeatableField}
        removeField={handleRemoveRepeatableField}
        onChangeField={handleOnChangeRepeatableFields}
        placeHolderText="Point"
        extraContainerClasses="mt-5"
        inputBoxMaxWidth="max-w-[500px]"
      />
    </>
  );
};

export default ServiceInfoFieldSection;
